module.exports = __webpack_public_path__ + "img/e-finder-plugged.bde5cfca.jpg";